import { FunctionComponent } from 'react';
import { graphql, useFragment } from 'react-relay';
import { filterFalsy } from 'dibs-ts-utils/exports/filterFalsy';

import { CheckoutAddressView_address$key } from './__generated__/CheckoutAddressView_address.graphql';

import style from './styles/checkoutAddressView.scss';

type RowProps = {
    content: string;
};

const AddressRow: FunctionComponent<RowProps> = ({ content }) => (
    <div className={style.row} key={content}>
        {content}
    </div>
);

const addressFragment = graphql`
    fragment CheckoutAddressView_address on Address {
        displayName
        company
        formattedAddress
        displayCountry
        phoneNumber
    }
`;

type Props = {
    address: CheckoutAddressView_address$key;
    hidePhoneNumber?: boolean;
};

export const CheckoutAddressView: FunctionComponent<Props> = props => {
    const { hidePhoneNumber = false } = props;

    const address = useFragment(addressFragment, props.address);
    const { displayName, company, formattedAddress, displayCountry, phoneNumber } = address;

    const addresRows = [company, ...(formattedAddress || []), displayCountry].filter(filterFalsy);

    return (
        <div>
            {!!displayName && <AddressRow content={displayName} />}
            {!!addresRows.length && <AddressRow content={addresRows.join(', ')} />}
            {!hidePhoneNumber && !!phoneNumber && <AddressRow content={phoneNumber} />}
        </div>
    );
};
